import React, { useState } from 'react';
import { Avatar, Box, Hidden, Divider,Container,Grid } from '@material-ui/core';
// import musafirbazarlogo from "../../assets/images/musafirbazarlogo.png";
// import musafirbazarlogo from '../../assets/images/click.PNG';
// import musafirbazarlogo from "../../assets/images/trip.png";
import AA from '../../assets/images/AA.jpg';
// import fly365 from '../../assets/images/fly365.png';
// import musafirbazarlogo from '../../assets/images/worldwide.png';
// import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import TitleText from './TitleText';
import IMAGES from '../../constants/logo.js';
import { useHistory } from 'react-router-dom';
import BodyText from './BodyText';
import { useDispatch, useSelector } from 'react-redux';
import SuccessModal from './SuccessModal';
import {
	setForgot,
	toggleRegisterModal,
	toggleRegisterTravellerModal,
	// setSection,
	toggleLoginModal
} from '../../reducers/UiReducer';
import {
	agentloginDispatch,
	travellerloginDispatch,
	agentloginSuccess
} from '../../reducers/UserReducer';
import ErrorModal from './ErrorModal';
import RegisterAgentModal from './RegisterAgentModal';
import RegisterTravellerModal from './RegisterTravellerModal';
const HeaderSection = ({ id }) => {
	const dispatch = useDispatch();
	const handleTheme = () => {
		let themeBtn = document.querySelector('#theme-btn');
		themeBtn.classList.toggle('fa-sun');

		if (themeBtn.classList.contains('fa-sun')) {
			document.body.classList.add('active');
		} else {
			document.body.classList.remove('active');
		}
	};

	const [user, setUser] = useState({
		username: '',
		password: '',
	});
	const { username, password } = user;
	const onInputChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};
	const onSubmit = async (e) => {
		e.preventDefault();
		var dat = user;
		var formData = JSON.stringify(dat);
		console.log(formData);
		// dispatch(travellerloginDispatch(formData, history));
		dispatch(agentloginDispatch(formData, history));
	};
	const onSubmit2 = async (e) => {
		e.preventDefault();
		var dat = user;
		var formData = JSON.stringify(dat);
		console.log(formData);
		dispatch(travellerloginDispatch(formData, history));
		// dispatch(agentSignupDispatch(formData, history));
	};
	const history = useHistory();
	const {section} = useSelector((state)=>state.ui)
	const handleChange = (e) => {
		console.log(e.target.name[0]);
	};
	const { travellerlogin, agentlogin, walletagent, wallet, agentlogoget } =
		useSelector((state) => state.user);
	const { logo } = useSelector((state) => state.home);
	return (
	<>
	<Hidden only={["xs"]}>
          <div style={{ background: "rgb(0, 87, 94)", padding: "6px 8px" }}>
            <Container>
              <Grid container>
                <Grid item xs={6}></Grid>
                <Grid item xs={6}>
                  <Box display="flex" alignItems="center" justifyContent="end">
                    <Box>
                      <span
                        style={{
                          marginLeft: 10,
                          color: "white",
                          fontSize: 14,
                        }}
                      >
                        Web Check-in
                      </span>
                    </Box>
                   
                    <Box>
                      <span
                        style={{
                          marginLeft: 10,
                          color: "white",
                          fontSize: 14,
                        }}
                      >
                        Email: contact@aryaaviation.com
                      </span>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </div>
        </Hidden>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{
            marginTop: 5,
            background: "white",
            paddingLeft:10,
            paddingRight:10,
            // paddingBottom:10
          }}
        >
          <Box onClick={()=>history.push('/')} style={{cursor:'pointer'}}>
            {/* <img src={AA} style={{ height: 50 }}></img> */}
            <span
              style={{
                color: "#8b0000f2",
                fontSize: "26px",
                fontWeight: 600,
                fontFamily: "cursive",
              }}
            >
             Demo
            </span>
          </Box>
          <Hidden only={["xs"]}>
            <Box display="flex">
              <Box
                display="flex"
                alignItems="center"
                onClick={() => {
                  // dispatch(setSection('flight'));
                  // history.push('/');
                }}
              >
                <i
                  class="fas fa-plane-departure"
                  style={{
                    // color:
                    //   section === "flight"
                    //     ? "rgb(0, 87, 94)"
                    //     : "rgb(10, 149, 255)",
                    cursor: "pointer",
                  }}
                ></i>
                <span
                  style={{
                    // color:
                    //   section === "flight"
                    //     ? "rgb(0, 87, 94)"
                    //     : "rgb(10, 149, 255)",
                    marginLeft: 5,
                    cursor: "pointer",
                  }}
                >
                  Flight
                </span>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                ml={"20px"}
                onClick={() => {
                //   dispatch(setSection("bus"));
                  history.push("/");
                }}
              >
                <i
                  class="fas fa-bus"
                  style={{
                    // color:
                    //   section === "bus"
                    //     ? "rgb(0, 87, 94)"
                    //     : "rgb(10, 149, 255)",
                    cursor: "pointer",
                  }}
                ></i>
                <span
                  style={{
                    // color:
                    //   section === "bus"
                    //     ? "rgb(0, 87, 94)"
                    //     : "rgb(10, 149, 255)",
                    marginLeft: 5,
                    cursor: "pointer",
                  }}
                >
                  Buses
                </span>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                ml={"20px"}
                onClick={() => {
                //   dispatch(setSection("hotel"));
                  history.push("/");
                }}
              >
                <i
                  class="fas fa-building"
                  style={{
                    // color:
                    //   section === "hotel"
                    //     ? "rgb(0, 87, 94)"
                    //     : "rgb(10, 149, 255)",
                    cursor: "pointer",
                  }}
                ></i>

                <span
                  style={{
                    // color:
                    //   section === "hotel"
                    //     ? "rgb(0, 87, 94)"
                    //     : "rgb(10, 149, 255)",
                    marginLeft: 5,
                    cursor: "pointer",
                  }}
                >
                  Hotels
                </span>
              </Box>

              <Box
                display="flex"
                alignItems="center"
                ml={"20px"}
                mr={"30px"}
                onClick={() => history.push("/")}
              >
                <a
                  href="#"
                  target="_blank"
                >
                  <i
                    class="fas fa-umbrella-beach"
                    style={{ color: "#0A95FF", cursor: "pointer" }}
                  ></i>
                  <span
                    style={{
                      color: "#0A95FF",
                      marginLeft: 5,
                      cursor: "pointer",
                    }}
                  >
                    Holidays
                  </span>
                </a>
              </Box>
              <Hidden only={["xs"]}>
                <Box display="flex" alignItems="center">
                  {travellerlogin && travellerlogin.status === 200 ? (
                    <Box
                      ml={"10px"}
                      display="flex"
                      alignItems="center"
                      style={{ cursor: "pointer" }}
                      onClick={() => history.push("/dashboard")}
                    >
                      <Avatar
                        style={{
                          color: "white",
                          background: "rgb(239, 51, 57)",
                        }}
                      >
                        {travellerlogin &&
                          travellerlogin.result &&
                          travellerlogin.result.result.name
                            .match(/(\b\S)?/g)
                            .join("")
                            .match(/(^\S|\S$)?/g)
                            .join("")
                            .toUpperCase()}
                      </Avatar>
                    </Box>
                  ) : agentlogin && agentlogin.status === 200 ? (
                    <Box style={{ alignItems: "center" }} display="flex">
                      <Box
                        style={{
                          marginRight: 10,
                          fontSize: 19,
                          cursor: "pointer",
                        }}
                        onClick={() => history.push("/dashboard")}
                      >
                        {agentlogin ? agentlogin?.result.result.agencyName : ""}
                      </Box>
                      <Box
                        style={{ marginRight: 15, cursor: "pointer" }}
                        onClick={() => {
                          dispatch(agentloginSuccess(null));
                          // dispatch(walletSuccess(null));
                          // dispatch(walletagentSuccess(null));
                          sessionStorage.removeItem("userInfoAgent");
                          history.push("/");
                        }}
                      >
                        Signout
                      </Box>
                      <Box style={{ fontSize: 20, marginRight: 15 }}>
                        ₹ Available Balance:{" "}
                        {walletagent ? walletagent?.result.balanceAmount : ""}
                      </Box>
                      <Avatar
                        onClick={() => history.push("/dashboard")}
                        style={{
                          color: "white",
                          background: "rgb(239, 51, 57)",
                          marginRight: 15,
                          cursor: "pointer",
                        }}
                      >
                        {agentlogin &&
                          agentlogin.result &&
                          agentlogin.result.result.name
                            .match(/(\b\S)?/g)
                            .join("")
                            .match(/(^\S|\S$)?/g)
                            .join("")
                            .toUpperCase()}
                      </Avatar>
                    </Box>
                  ) : (
                    <>
                      <Box
                        onClick={() => dispatch(toggleLoginModal(true))}
                        style={{
                          background: "rgb(7, 124, 193)",
                          color: "white",
                          padding: "8px",
                          fontWeight: "bold",
                          fontSize: ".8em",
                          cursor: "pointer",
                        }}
                      >
                        Login or Create Account
                      </Box>
                    </>
                  )}
                </Box>
              </Hidden>
            </Box>
          </Hidden>
        </Box>
	</>
	);
};

export default HeaderSection;
